import { render, staticRenderFns } from "./TheStepsPointsList.vue?vue&type=template&id=b05dd1ee&"
import script from "./TheStepsPointsList.vue?vue&type=script&lang=js&"
export * from "./TheStepsPointsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports